<template>
    <div class="gl-num-pager">
        <div class="container">
            <a class="previus" title="prev" @click="prevPage" :style="displayPrev">
                <i class="gli-previus"></i>
            </a>
            <p class="display">
                <span class="current-page">{{currentPage}}</span>                
                <template v-if="last > 0">
                    /<span class="max-page">{{last}}</span>
                </template>
            </p>
            <a class="next" title="next" @click="nextPage" :style="displayNext">
                <i class="gli-next"></i>
            </a>
        </div>
    </div>
</template>

<script>
export default {    
    name: 'gl-pager',
    props: {
        current: {
            type: Number,
            default: 1
        },
        last: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            currentPage: 1,
            styleHidden: {
                opacity: 0,
                cursor: 'pointer',
                display: 'none'
            },
            styleDisplay: {
                cursor: 'pointer'
            }
        }
    },
    computed:{
        displayPrev() {
            return this.currentPage > 1 ? this.styleDisplay : this.styleHidden;
        },
        displayNext() {
            const $result = this.currentPage < this.last ? this.styleDisplay : this.styleHidden;
            return $result;
        }
    },
    methods: {
        nextPage(){
            let current = this.currentPage;
            current++;
            if(this.last > 0 && current > this.last){
                current = this.last;
            }
            this.$set(this, 'currentPage', current);
            this._emitPage();
        },
        prevPage() {
            let current = this.currentPage;
            current--;
            if(current < 0) {
                current = 1;
            }
            this.$set(this, 'currentPage', current);
            this._emitPage();
        },
        _emitPage(){            
            this.$emit('change', this.currentPage);
        }
    },
    mounted() {
        this.$set(this, 'currentPage', this.current);
    }
}
</script>




// WEBPACK FOOTER //
// src/groovielize/components/Paginator.vue